/* DHC v1052.22 — successful Add to Cart always opens professional drawer */
(function(){
  var opening=false;
  function openDrawer(){
    if(opening) return;
    opening=true;
    window.setTimeout(function(){
      try{
        if(typeof window.DHCOpenCartDrawer==='function'){
          window.DHCOpenCartDrawer();
        }else{
          var d=document.querySelector('[data-cart-drawer][data-cart-build="v1052.20"], [data-cart-drawer]');
          var o=document.querySelector('[data-cart-overlay]');
          if(d){
            try{ if(typeof window.DHCCloseJack==='function') window.DHCCloseJack(); }catch(_e){}
            d.classList.add('is-open');
            d.setAttribute('aria-hidden','false');
            document.body.classList.add('dhc-cart-open');
            document.documentElement.classList.add('dhc-cart-open');
            if(o) o.classList.add('is-open');
          }
        }
      } finally {
        window.setTimeout(function(){opening=false;},250);
      }
    },30);
  }

  document.addEventListener('dhc:cart:updated',function(){ openDrawer(); });
  document.addEventListener('cart:refresh',function(){ openDrawer(); });
})();
